import { render, staticRenderFns } from "./DefaultPageModal.vue?vue&type=template&id=505d2448&scoped=true&"
import script from "./DefaultPageModal.vue?vue&type=script&lang=js&"
export * from "./DefaultPageModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageModal.vue?vue&type=style&index=0&id=505d2448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d2448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
